module.exports = __webpack_public_path__ + "static/media/pentland-brands-canterbury.3594afd8.jpg";